/**
 * @generated SignedSource<<63af135926a08c206a0164226a279c43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrowseChannelsModalJoinChannelMutation$variables = {
  channelId: string;
};
export type BrowseChannelsModalJoinChannelMutation$data = {
  readonly joinChannel: {
    readonly channel: {
      readonly id: string;
      readonly isMember: boolean;
      readonly members: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      }>;
    };
  } | null;
};
export type BrowseChannelsModalJoinChannelMutation = {
  response: BrowseChannelsModalJoinChannelMutation$data;
  variables: BrowseChannelsModalJoinChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channelId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "channelId",
        "variableName": "channelId"
      }
    ],
    "concreteType": "JoinChannel",
    "kind": "LinkedField",
    "name": "joinChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Channel",
        "kind": "LinkedField",
        "name": "channel",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMember",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrowseChannelsModalJoinChannelMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrowseChannelsModalJoinChannelMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3dc6ac15fe92deb4e4bfe0ca18cd85aa",
    "id": null,
    "metadata": {},
    "name": "BrowseChannelsModalJoinChannelMutation",
    "operationKind": "mutation",
    "text": "mutation BrowseChannelsModalJoinChannelMutation(\n  $channelId: ID!\n) {\n  joinChannel(channelId: $channelId) {\n    channel {\n      id\n      isMember\n      members {\n        id\n        email\n        fullName\n        image\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b0fae99ef6080272d24f29c0b86d32c";

export default node;
